// Dependencies
var _ = require('underscore');
var Marionette = require('backbone.marionette');
var startsWith = require('underscore.string/startsWith');

/*
EntitiesAPI

An object to encapsulate registering and unreigstering Backbone.Radio calls to retrieve entities.
On initialization, an Entities API object inspects its prototype for any methods beginning 'reply*'
and adds a radio request call on the supplied channel according to the following transformation:
    replySomeObject -> some:object

When the API is destroyed, the radio signals are unregistered. This is especially useful for testing,
where the same global Radio channels are maintained between tests in the test environment

Options:
channel (required): The Backbone.Radio channel the calls are registered on

radioPrefix: a prefix attached to the beginning of the radio signal, so
    replySomeObject -> prefix:some:object
By default, the prefix is 'entities'


NOTE: because this introspects the constructor's prototype to register the radio commands, it can
only be subclassed ONCE
*/

var EntitiesAPI = Marionette.Object.extend({
    constructor: function(options) {
        Marionette.Object.prototype.constructor.call(this, options);
        this.registerRadioCommands();
        this.once('destroy', this.unregisterRadioCommands);
    },
    registerRadioCommands: function() {
        _.each(
            this.constructor.prototype,
            function(value, prop) {
                if (startsWith(prop, 'reply')) {
                    this.getOption('channel').reply(
                        this._convertMethodName(prop),
                        function() {
                            return this[prop].apply(this, arguments);
                        },
                        this
                    );
                }
            },
            this
        );
    },
    unregisterRadioCommands: function() {
        _.each(
            this.constructor.prototype,
            function(value, prop) {
                if (startsWith(prop, 'reply')) {
                    this.getOption('channel').stopReplying(this._convertMethodName(prop));
                }
            },
            this
        );
    },
    radioPrefix: 'entities',
    _convertMethodName: function(name) {
        var colonized = name
            .replace(/^reply/, '')
            .replace(/([a-z\d])([A-Z]+)/g, '$1:$2')
            .toLowerCase();
        if (this.getOption('radioPrefix')) {
            colonized = this.getOption('radioPrefix') + ':' + colonized;
        }
        return colonized;
    },
});

// updates the state of a model in a collection to the state of a different instance of the same model outside the collection
// if passed an accessor, it uses that to retrieve a sync a nested collection/model instead of all the data
var syncCollectionToModel = function(collection, model, accessor) {
    if (!collection || !model) {
        return;
    }

    var collectionModel = collection.get(model.id);

    if (!collectionModel) {
        return;
    }

    var instanceToSync = accessor ? collectionModel[accessor]() : collectionModel;
    var data = accessor ? model[accessor]().toJSON() : model.toJSON();
    instanceToSync.set(data);
};

module.exports = {
    EntitiesAPI: EntitiesAPI,
    syncCollectionToModel: syncCollectionToModel,
};
